import { AppRouteObject } from "../components/feature/types/feature-types";

export const route: AppRouteObject = {

    path: "errors",
    children: [
        {
            path: "internal-server-error",
            lazy: async () => {
                const { Page } = await import("@/pages/errors/internal-server-error");
                return { Component: Page };
            },
        },
        {
            path: "not-authorized",
            lazy: async () => {
                const { Page } = await import("@/pages/errors/not-authorized");
                return { Component: Page };
            },
        },
        {
            path: "not-found",
            lazy: async () => {
                const { Page } = await import("@/pages/errors/not-found");
                return { Component: Page };
            },
        },
    ],
}
